import { useArcAuth } from "@arcauth/react-sdk";
import React from "react";
import { useSelector } from "react-redux";
import { RootStateType } from "../redux/features/rootSlice";

export default function Logo() {
const {user} = useArcAuth();
const configData:any = useSelector((state:RootStateType)=>state.configStateReducer.clientConfig);
  return (
    <img src={configData?.logoURL} alt="" />
  );
}